import type { LscMyJoinRequest } from './types';

export type MyJoinRequestBadgeStatus =
  | 'pending'
  | 'approved'
  | 'rejected'
  | 'member_active'
  | 'cancelled';

export function myJoinRequestBadgeStatus(
  item: Pick<LscMyJoinRequest, 'display_status' | 'status'>
): MyJoinRequestBadgeStatus {
  const display = item.display_status || item.status || 'pending';
  if (
    display === 'pending' ||
    display === 'approved' ||
    display === 'rejected' ||
    display === 'member_active' ||
    display === 'cancelled'
  ) {
    return display;
  }
  return 'pending';
}

export function myJoinRequestBadgeLabel(status: MyJoinRequestBadgeStatus): string {
  switch (status) {
    case 'pending':
      return 'Pending';
    case 'approved':
      return 'Approved';
    case 'rejected':
      return 'Rejected';
    case 'member_active':
      return 'Active Member';
    case 'cancelled':
      return 'Cancelled';
    default:
      return 'Pending';
  }
}

export function myJoinRequestBadgeClass(status: MyJoinRequestBadgeStatus): string {
  switch (status) {
    case 'pending':
      return 'bg-amber-500/20 text-amber-200 border-amber-500/40';
    case 'approved':
    case 'member_active':
      return 'bg-emerald-500/20 text-emerald-200 border-emerald-500/40';
    case 'rejected':
      return 'bg-rose-500/20 text-rose-200 border-rose-500/40';
    case 'cancelled':
      return 'bg-secondary-600/40 text-secondary-300 border-secondary-500/40';
    default:
      return 'bg-secondary-600/40 text-secondary-300 border-secondary-500/40';
  }
}

export function myJoinRequestStatusMessage(item: LscMyJoinRequest): string {
  if (item.message) return item.message;
  const status = myJoinRequestBadgeStatus(item);
  switch (status) {
    case 'pending':
      return 'Your request is waiting for commissioner approval.';
    case 'approved':
    case 'member_active':
      return "You're approved for this league. Open the Stream Center workspace.";
    case 'rejected':
      return 'Your request was not approved. Ask your commissioner for a new invite if needed.';
    default:
      return 'League access request.';
  }
}

export function myJoinRequestShowsOpenLeague(item: LscMyJoinRequest): boolean {
  return Boolean(item.can_open_league && item.league_id);
}
